import { Document, DocumentType, ClauseType } from '../../types';

// Mock Documents
export const mockDocuments: Document[] = [
  {
    id: '1',
    name: 'Office Lease - 123 Main St',
    type: DocumentType.Lease,
    project_id: 'project-1',
    file_type: 'pdf',
    uploadDate: '2023-01-15T10:30:00Z',
    created_at: '2023-01-15T10:30:00Z',
    uploadedBy: '1',
    versions: [
      {
        id: 'v1',
        version: 1,
        date: '2023-01-15T10:30:00Z',
        updatedBy: '1',
      },
    ],
    summary: 'Office lease agreement for 123 Main St property with ABC Corporation as tenant.',
    clauses: [
      {
        id: 'c1',
        type: ClauseType.RentEscalation,
        summary: '3% annual rent escalation',
        content: 'Rent shall increase by 3% annually on the anniversary of the Commencement Date.',
        documentId: '1',
        page: 5,
      },
      {
        id: 'c2',
        type: ClauseType.TermLength,
        summary: '5-year initial term',
        content: 'The initial Term shall be five (5) years commencing on the Commencement Date.',
        documentId: '1',
        page: 3,
      },
    ],
  },
  {
    id: '2',
    name: 'Purchase and Sale Agreement - Retail Portfolio',
    type: DocumentType.PSA,
    project_id: 'project-2',
    file_type: 'pdf',
    uploadDate: '2023-02-20T14:45:00Z',
    created_at: '2023-02-20T14:45:00Z',
    uploadedBy: '2',
    versions: [
      {
        id: 'v1',
        version: 1,
        date: '2023-02-20T14:45:00Z',
        updatedBy: '2',
      },
      {
        id: 'v2',
        version: 2,
        date: '2023-02-25T09:15:00Z',
        updatedBy: '1',
      },
    ],
    summary: 'Purchase and sale agreement for the acquisition of a 3-property retail portfolio in the Midwest.',
    clauses: [
      {
        id: 'c3',
        type: ClauseType.Other,
        summary: 'Purchase price of $45M',
        content: 'The purchase price for the Portfolio shall be Forty-Five Million Dollars ($45,000,000).',
        documentId: '2',
        page: 2,
      },
    ],
  },
  {
    id: '3',
    name: 'Joint Venture Agreement - XYZ Development',
    type: DocumentType.JVAgreement,
    project_id: 'project-3',
    file_type: 'docx',
    uploadDate: '2023-03-10T11:20:00Z',
    created_at: '2023-03-10T11:20:00Z',
    uploadedBy: '1',
    versions: [
      {
        id: 'v1',
        version: 1,
        date: '2023-03-10T11:20:00Z',
        updatedBy: '1',
      },
    ],
    summary: 'Joint venture agreement with XYZ Development for the mixed-use project in downtown.',
    clauses: [
      {
        id: 'c4',
        type: ClauseType.Other,
        summary: 'Profit distribution 70/30',
        content: 'Profits shall be distributed 70% to Investor and 30% to Developer after return of capital.',
        documentId: '3',
        page: 12,
      },
    ],
  },
  {
    id: '4',
    name: 'Offering Memorandum - Parkview Apartments',
    type: DocumentType.OfferingMemorandum,
    project_id: 'project-4',
    file_type: 'pdf',
    uploadDate: '2023-04-05T09:15:00Z',
    created_at: '2023-04-05T09:15:00Z',
    uploadedBy: '4',
    versions: [
      {
        id: 'v1',
        version: 1,
        date: '2023-04-05T09:15:00Z',
        updatedBy: '4',
      },
    ],
    summary: 'Offering memorandum for Parkview Apartments, a 250-unit multifamily property in Phoenix, AZ.',
    clauses: [],
  },
  {
    id: '5',
    name: 'Sponsor Model - Parkview Apartments',
    type: DocumentType.SponsorModel,
    project_id: 'project-5',
    file_type: 'xlsx',
    uploadDate: '2023-04-06T14:30:00Z',
    created_at: '2023-04-06T14:30:00Z',
    uploadedBy: '4',
    versions: [
      {
        id: 'v1',
        version: 1,
        date: '2023-04-06T14:30:00Z',
        updatedBy: '4',
      },
    ],
    summary: 'Financial model provided by the sponsor for Parkview Apartments acquisition.',
    clauses: [],
  },
];
